import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/',
  timeout: 10000,
  withCredentials: true
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加JWT token到请求头
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误')
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 如果是文件下载，直接返回
    if (response.config.responseType === 'blob') {
      return response
    }

    // 判断业务状态码（webman使用code=0表示成功）
    if (res.code !== 0 && res.code !== 200) {
      ElMessage.error(res.msg || res.message || '请求失败')
      
      // 特定错误码处理
      if (res.code === 401) {
        // Token 过期或未登录
        ElMessage.error('登录已过期，请重新登录')
        // 可以在这里处理登出逻辑
      }
      return Promise.reject(new Error(res.msg || res.message || '请求失败'))
    }
    
    // 成功时返回完整响应对象，包含code、msg、data等字段
    return res
  },
  error => {
    console.error('响应错误')
    const status = error.response?.status
    if (status === 401) {
      // Token 无效或已过期，清除本地凭证并跳转登录页
      localStorage.removeItem('Admin-Token')
      localStorage.removeItem('User-Info')
      ElMessage.error('登录已过期，请重新登录')
      window.location.hash = '#/login'
      return Promise.reject(error)
    }
    const message = error.response?.data?.message || error.message || '请求失败'
    ElMessage.error(message)
    return Promise.reject(error)
  }
)

// 先导出具名导出
export const request = service

// 再导出默认导出
export default request